export {
  HorizontalSeparator,
  HorizontalSeparatorForPostCard,
  VerticalSeparator,
  BulletSeparator,
  BulletSeparatorForPost,
  Spacing,
} from './separator';
